import { useTranslation } from "react-i18next";

const PriceLabel = ({ product, showCurrency = false }) => {
  const { t } = useTranslation();

  if (product.price > 0) {
    const price = Number(product.price).toFixed(2);

    return showCurrency ? `${price} €` : price;
  }

  return (
    <a
      className="font-medium underline"
      href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}
    >
      {t("Info")}
    </a>
  );
};

export default PriceLabel;
